import {
  getSplitIOTreatment,
  getSplitIOTreatmentWithConfig,
} from 'src/services/splitIOService';

/**
 * Helper to check simple boolean flags. Use if your flag just has simple
 * on/off states and uses 'off' for the control.
 * @param flagName
 */
const checkBooleanFlag = (flagName: string) => () => {
  const treatment = getSplitIOTreatment(flagName);

  if (treatment === 'on') {
    return true;
  }
  if (treatment === 'off') {
    return false;
  }
  if (treatment === 'control') {
    return false;
  }
  return false;
};

/*
 * This file is the interface for getting all Split.io feature flags.
 * Keeping all the feature flags in one place makes it easy to see and manage all the active flags.
 */

/*
 * The Product Catalog (PC) data is different in staging vs production.
 * This flag allows us to point Design Pro to production PC data in any environment.
 * This helps us test our changes against production PC data.
 */
export const shouldUseProductionProductCatalog = checkBooleanFlag(
  'design-pro-use-production-product-catalog',
);

export const shouldUseMacheteFeatureAPI = checkBooleanFlag(
  'design-pro-use-machete-feature-api',
);

export const shouldFetchInitialModelTexturesSeparately = checkBooleanFlag(
  'design-pro-fetch-initial-textures-separately',
);

export const shouldUseWindowConsistentMeasurements = checkBooleanFlag(
  'design-pro-window-consistent-measurements',
);

export const shouldSaveDesignHDF = checkBooleanFlag(
  'design-pro-save-design-hdf',
);

export const shouldShowRenderings = () => {
  // this Split will contain more than one variations instead of 'on' / 'off'
  const treatment = getSplitIOTreatment('he_rendering-cta');
  return treatment !== 'off' && treatment !== 'control';
};

export const renderingCTATreatment = () =>
  getSplitIOTreatmentWithConfig('he_rendering-cta');

export const renderingCTAImageTreatment = () =>
  getSplitIOTreatmentWithConfig('he_rendering-cta-image');

export default {
  shouldFetchInitialModelTexturesSeparately,
  shouldUseMacheteFeatureAPI,
  shouldUseProductionProductCatalog,
  shouldUseWindowConsistentMeasurements,
  shouldShowRenderings,
  shouldSaveDesignHDF,
};
